import React, { useState } from 'react';
import './App.css';
import { AdminProvider } from './contexts/AdminContext';
import { DashboardProvider } from './contexts/DashboardContext';
import Sidebar from './components/Sidebar';
import AdminPasswordPrompt from './components/AdminPasswordPrompt';
import AdminBadge from './components/AdminBadge';
import DashboardSection from './sections/DashboardSection';
import PortfolioSection from './sections/PortfolioSection';
import MarketDataSection from './sections/MarketDataSection';
import AIInsightsSection from './sections/AIInsightsSection';
import TrackRecordSection from './sections/TrackRecordSection';
import { Toaster } from './components/ui/sonner';

function App() {
  const [activeSection, setActiveSection] = useState('dashboard');

  const renderSection = () => {
    switch (activeSection) {
      case 'dashboard':
        return <DashboardSection />;
      case 'portfolio':
        return <PortfolioSection />;
      case 'market':
        return <MarketDataSection />;
      case 'ai':
        return <AIInsightsSection />;
      case 'track':
        return <TrackRecordSection />;
      default:
        return <DashboardSection />;
    }
  };

  return (
    <AdminProvider>
      <DashboardProvider>
        <div className="flex min-h-screen bg-white">
          <Sidebar activeSection={activeSection} setActiveSection={setActiveSection} />
          <main className="flex-1 ml-64 p-8 overflow-y-auto">
            {renderSection()}
          </main>
          <AdminPasswordPrompt />
          <AdminBadge />
          <Toaster />
        </div>
      </DashboardProvider>
    </AdminProvider>
  );
}

export default App;